export const SALESHUB_CONTRACT_STATUS = {
  inProgress: 'In Progress',
  readyForSale: 'Ready for Sale',
  pendingFinalized: 'Pending Finalized',
  finalized: 'Finalized',
  cancelled: 'Cancelled'
}

export const IP_CONTRACT_STATUS = {
  preliminary: 'Preliminary',
  preliminaryPendingApproval: 'Preliminary, Pending approval',
  active: 'Active, No additional units',
  open: 'Active, Open to new units',
  sold: 'Sale Complete',
  closed: 'Closed',
  inactive: 'Inactive'
}

export const SALESHUB_CONTRACT_CHANNEL = {
  live : 'Live',
  online : 'Online',
  multichannel : 'Multi-channel'
}

export class ContractStatus {
  public static getContractStageColor(contractStage: string): string {
    let contractStageColor;
    switch(contractStage) {
      case SALESHUB_CONTRACT_STATUS.inProgress:
        contractStageColor = "text-yellow";
        break;
      case SALESHUB_CONTRACT_STATUS.readyForSale:
      case IP_CONTRACT_STATUS.preliminary:
        contractStageColor = "text-lightBlue";
        break;
      case SALESHUB_CONTRACT_STATUS.pendingFinalized:
      case IP_CONTRACT_STATUS.preliminaryPendingApproval:
        contractStageColor = "text-orange";
        break;
      case SALESHUB_CONTRACT_STATUS.finalized:
      case IP_CONTRACT_STATUS.active:
      case IP_CONTRACT_STATUS.open:
        contractStageColor = "text-green";
        break;
      case SALESHUB_CONTRACT_STATUS.cancelled:
      case IP_CONTRACT_STATUS.inactive:
        contractStageColor = "text-red";
        break;
      default:
        contractStageColor = "text-grey";
    }
    return contractStageColor;
  }

  public static isFinalized(status: string): boolean {
    return status === SALESHUB_CONTRACT_STATUS.pendingFinalized || status === SALESHUB_CONTRACT_STATUS.finalized;
  }
}
